import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { Subscription } from 'rxjs';

import { MegacablePlanMapper } from '../../../core/mappers/megacable-plan.mapper';
import { MobilePlanPromo, PlanSocialNetwork } from '../../../core/models/mobile-plan-promo.model';
import { MegacableService } from '../../../core/services/megacable.service';

const PLANS_UNAVAILABLE_MESSAGE =
  'No fue posible obtener los planes disponibles en este momento.';

export type PlansPromoLayout = 'home' | 'pdp';

@Component({
  selector: 'app-plans-promo',
  templateUrl: './plans-promo.component.html',
  styleUrls: ['./plans-promo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlansPromoComponent implements OnInit, OnDestroy {

  @Input() layout: PlansPromoLayout = 'home';
  @Input() selectable = false;
  @Input() selectedPlanId: string | null = null;

  @Output() planSelect = new EventEmitter<MobilePlanPromo>();

  plans: readonly MobilePlanPromo[] = [];
  loading = true;
  errorMessage: string | null = null;

  private _plansSub?: Subscription;

  constructor(
    private readonly _megacableService: MegacableService,
    private readonly _cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this._plansSub = this._megacableService.getPlans().subscribe((result) => {
      this.loading = false;
      this.errorMessage = result.unavailable ? PLANS_UNAVAILABLE_MESSAGE : null;
      this.plans = MegacablePlanMapper.toMobilePlanPromos(result.plans);
      this._cdr.markForCheck();
    });
  }

  ngOnDestroy(): void {
    this._plansSub?.unsubscribe();
  }

  trackByPlanId(_index: number, plan: MobilePlanPromo): string {
    return plan.id;
  }

  trackBySocial(_index: number, network: PlanSocialNetwork): string {
    return network;
  }

  socialIconClass(network: PlanSocialNetwork): string | null {
    const map: Partial<Record<PlanSocialNetwork, string>> = {
      facebook: 'fa-facebook',
      x: 'fa-twitter',
      instagram: 'fa-instagram',
      whatsapp: 'fa-whatsapp',
      snapchat: 'fa-snapchat-ghost',
      telegram: 'fa-telegram'
    };
    const icon = map[network];
    return icon ? `fa ${icon}` : null;
  }

  usesCustomSocialIcon(network: PlanSocialNetwork): boolean {
    return network === 'messenger';
  }

  isPlanSelected(plan: MobilePlanPromo): boolean {
    return this.selectable && this.selectedPlanId === plan.id;
  }

  onPlanCardClick(plan: MobilePlanPromo): void {
    if (!this.selectable) {
      return;
    }
    this.planSelect.emit(plan);
  }

  onPlanCardKeydown(event: KeyboardEvent, plan: MobilePlanPromo): void {
    if (!this.selectable || (event.key !== 'Enter' && event.key !== ' ')) {
      return;
    }
    event.preventDefault();
    this.planSelect.emit(plan);
  }

  onContractClick(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
  }
}
